import { render, staticRenderFns } from "./closeOnPressEscape-editor.vue?vue&type=template&id=1a2a51da&scoped=true&"
import script from "./closeOnPressEscape-editor.vue?vue&type=script&lang=js&"
export * from "./closeOnPressEscape-editor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a2a51da",
  null
  
)

export default component.exports